import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'
import { UserAttributes } from 'shared/types'

export const getAuth = (state: RootState) => state.common.auth

export const getIsAuthenticated = (state: RootState) =>
  state.common.auth.isAuthenticated

export const getAuthStatus = (state: RootState) => state.common.auth.loading

export const getAuthError = (state: RootState) => state.common.auth.error

export const getUserEmail = (state: RootState) =>
  state.common.auth.currentUserEmail

export const getRegisterData = (state: RootState) => state.common.auth.register

export const getLoginData = (state: RootState) => state.common.auth.login

export const getResetPasswordData = (state: RootState) =>
  state.common.auth.resetPassword

export const getSendForgotPasswordEmailData = (state: RootState) =>
  state.common.auth.sendForgotPasswordEmail

export const getResendActivationEmailState = (state: RootState) =>
  state.common.auth.resendActivationEmail

export const getCurrentUserInfo = (state: RootState) =>
  state.common.auth.currentUserInfo.data

export const getUserRole = createSelector(
  getCurrentUserInfo,
  userInfo => userInfo.attributes[UserAttributes.role]
)

export const getConfirmState = createSelector(getAuth, state => state.confirm)

export const getSetPasswordData = (state: RootState) =>
  state.common.auth.setNewPassord
